import { Chapter, WebinarStatus } from '@core/types';
import { Chapters } from '@online-webinar/chapters';
import { setActiveChapter, useAppDispatch, useAppSelector } from '@online-webinar/store';
import { useEffect } from 'react';
import { ChapterContent } from '../ChapterContent';

export const ChaptersContainer = () => {
    const dispatch = useAppDispatch();

    const status = useAppSelector((state) => state.liveWebinar.webinarData.status);
    const chapters = useAppSelector((state) => state.liveWebinar.chapters);
    const activeChapter = useAppSelector((state) => state.liveWebinar.activeChapter);
    const activeSlideNumber = useAppSelector((state) => state.liveWebinar.activeSlideNumber) || 0;

    const onChapterClick = (chapter: Chapter) => {
        dispatch(setActiveChapter(chapter.chapterId));
    };

    useEffect(() => {
        if (status !== WebinarStatus.Started) {
            // Do nothing if the webinar is not started
            return;
        }

        if (!chapters || chapters.length === 0) {
            return;
        }

        let activeChapterIndex = -1;
        if (activeChapter) {
            activeChapterIndex = chapters.findIndex((chapter) => chapter.chapterId === activeChapter.chapterId);
        }

        let newChapterIndex = chapters.findIndex((chapter) => chapter.slideToStartWith === activeSlideNumber + 1);
        if (activeChapterIndex < newChapterIndex) {
            dispatch(setActiveChapter(chapters[newChapterIndex].chapterId));
        }
    }, [status, activeSlideNumber, activeChapter, chapters]);

    return (
        <ChapterContent>
            <Chapters chapters={chapters} activeChapter={activeChapter} showHeader={false} onChapterClick={onChapterClick} />
        </ChapterContent>
    );
};
